import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { actions, selectors } from '@elab/core/store/payment';
import { actions as uiActions } from '@elab/core/store/ui';

export class RemoveCardDialog extends SimpleLitElement {
    static get properties() {
        return {
            cardType: { type: String, attribute: false },
            cardNumber: { type: String, attribute: false },
            cardId: { type: String, attribute: false },
            removePaymentActionUrl: {
                type: String,
                attribute: 'remove-payment-action-url',
            },
            cancelBtnLabel: { type: String, attribute: 'cancel-btn-label' },
            submitBtnLabel: { type: String, attribute: 'submit-btn-label' },
            removeCardMsg: { type: String, attribute: 'remove-card-msg' },
            token: { type: String, attribute: 'csrf-token' },
        };
    }

    constructor() {
        super();

        this.cardType = '';
        this.cardNumber = '';
        this.token = '';
    }

    onCancelClicked = event => {
        event.stopImmediatePropagation();
        event.preventDefault();
        this.dispatchEvent(
            new CustomEvent('close-dialog', {
                detail: 'remove-credit-card-popup',
            }),
        );
    };

    onDeleteButton = event => {
        event.stopImmediatePropagation();
        this.dispatchEvent(
            new CustomEvent('delete-card', {
                detail: 'remove-credit-card-payment-popup',
            }),
        );
    };

    renderFormButton = () => {
        return html`
            <form
                class="remove-dialog__form"
                id="removePaymentDetails${this.cardId}"
                action="${this.removePaymentActionUrl}"
                method="post"
            >
                <input type="hidden" name="paymentInfoId" value="${this.cardId}" />
                <input type="hidden" name="CSRFToken" value="${this.token}" />
                <div class="remove-dialog__btn-holder">
                    <button type="submit" class="button button--primary button--full-width">
                        ${this.submitBtnLabel}
                    </button>
                    <button
                        type="cancel"
                        class="button button--big button--full-width"
                        @click="${this.onCancelClicked}"
                    >
                        ${this.cancelBtnLabel}
                    </button>
                </div>
            </form>
        `;
    };

    renderButton = () => {
        return html`
            <div class="remove-dialog__btn-holder">
                <button
                    class="button button--primary button--full-width"
                    @click="${this.onDeleteButton}"
                >
                    ${this.submitBtnLabel}
                </button>
                <button
                    type="cancel"
                    class="button button--big button--full-width"
                    @click="${this.onCancelClicked}"
                >
                    ${this.cancelBtnLabel}
                </button>
            </div>
        `;
    };

    render() {
        this.cardType = this.cardType === 'mastercard' ? 'master' : this.cardType;
        return html`
            <div class="remove-dialog">
                <div class="remove-dialog__msg">
                    ${this.removeCardMsg}
                </div>
                <div class="remove-dialog__info-row">
                    <div class="remove-dialog__logo remove-dialog__logo--${this.cardType}"></div>
                    <div class="remove-dialog__text">
                        ${this.cardNumber}
                    </div>
                </div>
                ${this.token ? this.renderFormButton() : this.renderButton()}
            </div>
        `;
    }
}

const mapStateToProps = state => {
    return {
        cardType: selectors.getRemoveCardType(state),
        cardNumber: selectors.getRemoveCardNumber(state),
        cardId: selectors.getRemoveCardId(state),
    };
};

const mapDispatchToEvents = dispatch => {
    return {
        'close-dialog': () => dispatch(uiActions.closeDialog()),
        'delete-card': ({ detail }) => dispatch(actions.removeSelectedCard(detail)),
    };
};

export default () =>
    customElements.define(
        'e2-remove-card-popup',
        connect(mapStateToProps, mapDispatchToEvents)(RemoveCardDialog),
    );
